const priorityChoices = [
  { id: 5, name: 'P5 - Optional' },
  { id: 4, name: 'P4 - Low' },
  { id: 3, name: 'P3 - Medium' },
  { id: 2, name: 'P2 - High' },
  { id: 1, name: 'P1 - Urgent' },
];

export default priorityChoices;
